import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { LightStreaks } from "../components/LightStreaks";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username.trim(), password);
      toast.success("Zalogowano");
      nav("/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(
        typeof detail === "string" ? detail : "Nieprawidłowy login lub hasło"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="login-page"
      className="min-h-screen relative bg-[#1A1A2E] flex items-center justify-center px-6 overflow-hidden"
    >
      <LightStreaks density={5} />

      <Link
        to="/"
        data-testid="login-back-home"
        className="absolute top-6 left-6 inline-flex items-center gap-2 text-white/60 hover:text-white text-sm"
      >
        <ArrowLeft size={16} />
        Wróć na stronę
      </Link>

      <div className="relative w-full max-w-md">
        <div className="bg-[#1F1F38]/80 backdrop-blur-md border border-white/10 rounded-3xl p-8 md:p-10">
          <div className="flex items-center gap-3 mb-7">
            <div className="h-11 w-11 rounded-xl bg-stormly-cyan/10 border border-stormly-cyan/30 flex items-center justify-center">
              <Lock size={18} className="text-stormly-cyan" />
            </div>
            <div>
              <h1 className="font-heading text-2xl font-bold">Panel Stormly</h1>
              <p className="text-xs text-white/50">Tylko dla administratora</p>
            </div>
          </div>

          <form onSubmit={onSubmit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="text-xs uppercase tracking-widest text-white/60 font-bold mb-2 block">
                Login
              </label>
              <input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="form-input"
                placeholder="login"
                data-testid="login-username"
                autoComplete="username"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-white/60 font-bold mb-2 block">
                Hasło
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                placeholder="••••••••"
                data-testid="login-password"
                autoComplete="current-password"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="btn-primary w-full justify-center disabled:opacity-60"
            >
              {loading ? (
                <>
                  <Loader2 size={18} className="animate-spin" /> Logowanie...
                </>
              ) : (
                "Zaloguj się"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
